<!--
  *** 开发人员: 本页面:王臣; 其他页面暂时性维护.
  *** 开发时间: 2024-05-30
  *** 功能描述: 全链预警-行业景气
  *** 版本号: v1.0.0
  *** 版权所有: 上海大智慧信息科技有限公司，并保留所有权利。
 -->
<template>
  <div class="Hyjq" :class="themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <ul class="header_tab">
      <li>指标</li>
      <li
        class="sortable"
        :class="{
          active: currentSort === 'industryCode',
          asc: sortOrder === 'asc',
          desc: sortOrder === 'desc',
        }"
        @click="sort('industryCode')"
      >
        行业
      </li>
      <li
        class="sortable"
        :class="{
          active: currentSort === 'updateFreq',
          asc: sortOrder === 'asc',
          desc: sortOrder === 'desc',
        }"
        @click="sort('updateFreq')"
      >
        频度
      </li>
      <li
        class="sortable"
        :class="{
          active: currentSort === 'curZf',
          asc: sortOrder === 'asc',
          desc: sortOrder === 'desc',
        }"
        @click="sort('curZf')"
      >
        当期涨幅
      </li>
    </ul>

    <div class="hy_list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getHyList">
        <ul v-for="item in hyjqList" :key="item.indexId + item.industryCode" class="ul" @click="toDetail(item.indexId)">
          <li class="van-multi-ellipsis--l3">
            {{ item.factor.indexname }}
          </li>
          <li>{{ item.industryName }}</li>
          <li>{{ item.factor.updateFreqStr }}</li>
          <li :class="[judgeColor(item.curZf)]">
            {{ toFixedNum(item.curZf, 2, "%") }}
          </li>
        </ul>
      </van-list>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Hyjq",
    props: ["handleDataLoadedNum"],
    data() {
      return {
        hyjqList: [],
        loading: false,
        finished: false,
        pageNum: 1,
        themeStyleVs: 1,
        currentSort: "curZf", // 当前排序项
        sortOrder: "desc", // 排序顺序 asc升序 desc降序
      };
    },
    components: {},
    watch: {},
    computed: {},
    created() {},
    async mounted() {
      this.themeStyleVs = this.$route.query.themeStyleVs || 1;
    },
    methods: {
      //返回股票涨幅对应的颜色
      judgeColor: function (n) {
        if (n == 0) {
          return "gray";
        } else if (n > 0) {
          return "red";
        } else if (n < 0) {
          return "green";
        }
      },

      toFixedNum: function (value, toFixed = 2, unit = "") {
        if (value && value !== "--") {
          return Number(value).toFixed(toFixed) + unit;
        } else if (value === 0) {
          return "0.00" + unit;
        } else {
          return "--";
        }
      },
      getHyList: function () {
        let _this = this;
        _this
          .$http({
            method: "post",
            url: window.config.api_v1 + "/research-industry-sdk/industry-prosperity/page",
            data: {
              pageNum: _this.pageNum,
              pageSize: 20,
              qid: new Date(),
              param: {
                sortfield: _this.currentSort,
                sorttype: _this.sortOrder == "asc" ? 0 : 1, //排序方向 0-升序 1-降序(默认)
              },
            },
            headers: {
              Token: _this.$route.query.token,
            },
          })
          .then(function (res) {
            _this.hyjqList.push(...(res.data.data.data || []));

            let l = res.data.data.data || [];

            // 加载状态结束
            _this.loading = false;

            // 数据全部加载完成
            if (l.length < 20) {
              _this.finished = true;
            } else {
              _this.finished = false;
              _this.pageNum++;
            }

            if (_this.handleDataLoadedNum == 3) {
              _this.$emit("data-loaded"); // 发出事件通知父组件数据已经加载完毕
            }
          })
          .catch(function () {
            _this.finished = true;
            _this.hyjqList = [];
          });
      },

      toDetail: function (indexId) {
        let _this = this;

        const url = window.config.hyjq_detail;

        this.toUrl(`${url}/hyjqDetail?DZHSPECIAL=4194569&themeStyleVs=${_this.themeStyleVs}&indexId=${indexId}`);
        // _this.$router.push({
        //   path: "/hyjqDetail?DZHSPECIAL=1",
        //   query: {
        //     token: _this.$route.query.token,
        //     themeStyleVs: _this.themeStyleVs,
        //     indexId: indexId,
        //   },
        // });
      },

      sort(field) {
        if (this.currentSort === field) {
          // 如果再次点击相同的排序项，则切换排序顺序
          this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
        } else {
          // 点击不同的排序项，更新当前排序项和默认排序顺序
          this.currentSort = field;
          this.sortOrder = "asc"; // 默认升序
        }
        // 在这里调用实际的排序函数
        this.pageNum = 1;
        this.hyjqList = [];
        this.getHyList();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .red {
    color: #ef3939 !important;
  }
  .green {
    color: #1eac4e !important;
  }
  .gray {
    color: #999;
  }
  .Hyjq {
    padding: 0 0.16rem 0.16rem;
    height: calc(100vh - 0.86rem);
    overflow-y: auto;
    .header_tab {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: sticky;
      top: 0;
      width: 100%;
      background: #fff;
      li {
        color: #999;
        font-size: 0.14rem;
        flex: 1;
        text-align: right;
        position: relative;
        &:first-child {
          text-align: left;
        }
      }
    }
    .header_tab {
      padding-top: 0.05rem;

      .sortable {
        padding-right: 0.1rem; /* 为箭头图标留出空间 */
      }

      .sortable::before,
      .sortable::after {
        content: "";
        position: absolute;
        right: -0.02rem;
        border: 0.03rem solid transparent;
      }

      .sortable::before {
        border-bottom: 5px solid #ccc; /* 默认向上箭头颜色 */
        top: 0.01rem; /* 调整箭头位置 */
      }

      .sortable::after {
        border-top: 5px solid #ccc; /* 默认向下箭头颜色 */
        top: 0.11rem; /* 调整箭头位置 */
      }

      .sortable.active.asc::before {
        border-bottom-color: #286df7; /* 当前升序激活状态的颜色 */
      }

      .sortable.active.desc::after {
        border-top-color: #286df7; /* 当前降序激活状态的颜色 */
      }
    }

    .hy_list {
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.125rem 0;
        li {
          flex: 1;
          text-align: right;
          font-size: 0.14rem;
          &:first-child {
            text-align: left;
          }
          &:nth-child(1) {
            font-weight: 800;
            color: #1d2129;
          }
          &:nth-child(2),
          &:nth-child(3) {
            color: #222222;
          }
        }
      }
    }
  }

  .black_theme {
    .Hyjq .hy_list ul li {
      color: #e4e9fe;
    }
    .header_tab {
      background: #171922;
      .sortable::before {
        border-bottom: 5px solid #999; /* 默认向上箭头颜色 */
      }

      .sortable::after {
        border-top: 5px solid #999; /* 默认向下箭头颜色 */
      }
    }
  }
</style>
